import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useMyContext } from '../../../../context/MyContext';
import { FiLock, FiLink, FiExternalLink, FiCheck, FiAlertCircle, FiRefreshCw, FiX } from 'react-icons/fi';
import { Base_Url, scanSopifyConnectionStatus, scanSopifyauth ,allwarehouseslist} from "../../../../config/config";

import axios from 'axios';
import { toast } from "react-toastify";
import {
  Package,
  Users,
  TrendingUp,
  AlertCircle,
  RefreshCw,
  Sparkles,
  ShoppingBag
} from "lucide-react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer
} from "recharts";

export default function ShopifyConnect() {
  const { isDarkMode } = useMyContext();

  const [storeUrl, setStoreUrl] = useState('');
  const [touched, setTouched] = useState(false);
  const [fieldError, setFieldError] = useState('');
  const [hint, setHint] = useState('');
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [connectedStore, setConnectedStore] = useState(null);
  const [orders, setOrders] = useState([]);
  const [syncLoading, setSyncLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [dashboardStats, setDashboardStats] = useState({
    total_order: 0,
    total_delivered: 0,
    total_pending: 0,
    total_cod: 0,
    total_prepaid: 0,
    total_revenue: 0,
  });


  // New States for Warehouse Selection
  const [showWarehouseModal, setShowWarehouseModal] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouseId, setSelectedWarehouseId] = useState('');
  const [warehouseLoading, setWarehouseLoading] = useState(false);

  const ordersPerPage = 5;

  const isValidUrl = (url) => {
    try {
      const urlObj = new URL(url.startsWith('http') ? url : 'https://' + url);
      return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
    } catch {
      return false;
    }
  };

  const checkConnectionStatus = async () => {
    try {
      setLoading(true);

      const cus_id = localStorage.getItem("cus_id");
      const token = localStorage.getItem("token");

      const url = `${Base_Url}${scanSopifyConnectionStatus}/${cus_id}`;

      const response = await axios({
        method: "get", // backend GET me Content-Type issue de raha hai
        url: url,
        data: {}, // empty body
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "cus_id": cus_id,
          "token": token,
        },
      });

      const data = response.data;

      console.log("API Response:", data);

      if (data?.status === "connected") {
        setStatus("connected");
        setConnectedStore(data.store || data.data?.store);
      }
      else if (data?.status === "pending") {
        setStatus("pending");
        setStatusMessage(
          data.message ||
          "Your connection request is pending approval. Please contact admin."
        );
      }
      else {
        setStatus("not_connected");
      }

    } catch (error) {
      console.error("Status Check Error:", error.response?.data || error);
      setStatus("not_connected");
    } finally {
      setLoading(false);
    }
  };


  
      
  const fetchWarehouses = async () => {
    try {
      setWarehouseLoading(true);
      const cus_id = localStorage.getItem("cus_id");
      const token = localStorage.getItem("token");

      const res = await fetch(Base_Url + allwarehouseslist, {
        method: "GET",
        headers: { "Content-Type": "application/json", cus_id, token },
      });

      const data = await res.json();
      if (data.status === "SUCCESS") {
        setWarehouses(data.data || []);
      } else {
        toast.error("Failed to load warehouses");
      }
    } catch (err) {
      toast.error("Error loading warehouse list");
    } finally {
      setWarehouseLoading(false);
    }
  };

  // Open Modal and Fetch Warehouses
  const handleSyncClick = async () => {
    setSelectedWarehouseId('');           // Reset previous selection
    await fetchWarehouses();
    setShowWarehouseModal(true);
  };

  const syncShopifyOrders = async () => {
    if (!selectedWarehouseId) {
      toast.error("Please select a warehouse");
      return;
    }

    try {
      setSyncLoading(true);
      const cus_id = localStorage.getItem("cus_id");
      const token = localStorage.getItem("token");

      const res = await fetch(
        "https://api.pickupxpress.com/integration/shopify/sync-order",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            cus_id,
            token
          },
          body: JSON.stringify({
            warehouse_id: selectedWarehouseId,
            vendor_id: cus_id
          })
        }
      );

      const data = await res.json();

      if (data.status === "SUCCESS") {
        toast.success(data.message || "Orders Synced Successfully");
        setOrders(data.orders || []);
      } else {
        toast.error(data.message || "Sync Failed");
      }
    } catch {
      toast.error("Something went wrong");
    } finally {
      setSyncLoading(false);
      setShowWarehouseModal(false);
      setSelectedWarehouseId('');
    }
  };

  const syncShopifyDashboard = async () => {
    try {
      setSyncLoading(true);
      const cus_id = localStorage.getItem("cus_id");
      const token = localStorage.getItem("token");

      const res = await fetch(
        "https://api.pickupxpress.com/integration/shopify/dashboard",
        {
          method: "GET",
          headers: { "Content-Type": "application/json", cus_id, token },
        }
      );

      const data = await res.json();

      if (data.status === "SUCCESS") {
        const d = data.data || {};

        setDashboardStats({
          total_order: d.total_order || 0,
          total_delivered: d.total_delivered || 0,
          total_pending: d.total_pending || 0,
          total_cod: d.total_cod || 0,
          total_prepaid: d.total_prepaid || 0,
          total_revenue: d.total_revenue || 0,
        });

        const formattedOrders = (d.pending_orders || []).map((item) => ({
          id: item.order_id,
          customer: `${item.first_name || ''} ${item.last_name || ''}`.trim(),
          amount: item.total_amount || 0,
          status: item.status || 'Pending',
          date: item.created_at ? item.created_at.split(' ')[0] : '',
        }));

        setOrders(formattedOrders);
      }
    } catch (err) {
      console.error("Dashboard API Error:", err);
      toast.error("Failed to load dashboard data");
    } finally {
      setSyncLoading(false);
    }
  };

  useEffect(() => {
    checkConnectionStatus();
  }, []);

  useEffect(() => {
    if (status === "connected") {
      syncShopifyDashboard();
    }
  }, [status]);

  const handleUrlChange = (e) => {
    const value = e.target.value.trim();
    setStoreUrl(value);
    setTouched(true);

    if (value && !isValidUrl(value)) {
      setFieldError('Please enter a valid URL');
      setHint('');
    } else if (value) {
      setFieldError('');
      setHint('Looks good! Click Connect.');
    } else {
      setFieldError('');
      setHint('');
    }
  };

  const handleSubmit = async () => {
    if (!isValidUrl(storeUrl)) return;

    try {
      setLoading(true);

      const cus_id = localStorage.getItem("cus_id");
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${Base_Url}${scanSopifyauth}`,
        {
          shop: storeUrl,
          vendor_id: cus_id
        },
        {
          headers: {
            "Content-Type": "application/json",
            cus_id,
            token
          }
        }
      );

      const data = response.data;

      if (data?.status === "success" && data?.data?.url) {
        window.open(
          data.data.url,
          "ShopifyOAuth",
          "width=700,height=750,left=300,top=80"
        );
      } else {
        toast.error("Authentication failed");
      }
    } catch {
      toast.error("Failed to connect Shopify");
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(orders.length / ordersPerPage);

  const currentOrders = orders.slice(
    (currentPage - 1) * ordersPerPage,
    currentPage * ordersPerPage
  );

  if (loading) {
    return (
      <div className={`h-screen flex items-center justify-center relative overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gray-50'}`}>
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          <div className="absolute -top-24 left-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-indigo-500/10 rounded-full blur-3xl" />
        </div>
        <div className="flex flex-col items-center gap-4 relative">
          <div className="p-5 rounded-2xl bg-gradient-to-br from-purple-500 to-indigo-600 shadow-xl shadow-purple-500/30">
            <FiRefreshCw className="animate-spin text-white" size={32} />
          </div>
          <p className={`font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Checking Shopify connection status...</p>
        </div>
      </div>
    );
  }


  if (status === 'connected') {
    return (
      <div className={`flex flex-col ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
        <div className={`p-6 lg:p-8 relative ${isDarkMode ? 'bg-darkmodeColor' : 'bg-gray-50'}`}>
          <div className="pointer-events-none absolute inset-0 overflow-hidden">
            <div className="absolute -top-24 left-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl" />
            <div className="absolute top-1/3 right-0 w-96 h-96 bg-indigo-500/10 rounded-full blur-3xl" />
            <div className="absolute bottom-0 left-0 w-80 h-80 bg-fuchsia-500/10 rounded-full blur-3xl" />
          </div>

          <div className="max-w-7xl mx-auto relative">

            {/* Header */}
            <motion.div
              initial={{ opacity: 0, y: -16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-10"
            >
              <div>
                <div className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-3 border ${isDarkMode ? 'bg-white/5 border-white/10 text-purple-300' : 'bg-purple-50 border-purple-200 text-purple-600'} text-xs font-semibold tracking-wide uppercase`}>
                  <Sparkles className="w-3.5 h-3.5" />
                  Shopify Connected
                </div>
                <h1 className={`text-3xl md:text-4xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r ${isDarkMode ? 'from-white via-purple-200 to-indigo-200' : 'from-gray-900 via-purple-700 to-indigo-700'}`}>
                  Shopify Overview
                </h1>
                <p className={`mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                  Connected to: <span className="font-semibold text-purple-600">
                    {connectedStore?.store_name || 'Your Store'}
                  </span>
                </p>
              </div>

              <button
                onClick={handleSyncClick}
                disabled={syncLoading}
                className="flex items-center gap-2 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white px-6 py-3 rounded-2xl font-medium transition-all shadow-lg shadow-purple-500/30 active:scale-95 disabled:opacity-70"
              >
                <RefreshCw className={`w-5 h-5 ${syncLoading ? 'animate-spin' : ''}`} />
                {syncLoading ? 'Syncing...' : 'Sync Shopify Orders'}
              </button>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
              {[
                { icon: Package, label: "Total Orders", value: dashboardStats.total_order, accent: 'from-purple-500 to-violet-600' },
                { icon: Users, label: "Delivered", value: dashboardStats.total_delivered, accent: 'from-indigo-500 to-blue-600' },
                { icon: TrendingUp, label: "Revenue", value: `₹${dashboardStats.total_revenue}`, accent: 'from-emerald-500 to-teal-600' },
                { icon: AlertCircle, label: "Pending", value: dashboardStats.total_pending, accent: 'from-fuchsia-500 to-purple-600' },
              ].map((item, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  whileHover={{ y: -6 }}
                  className={`${isDarkMode ? 'bg-white/[0.06] backdrop-blur-xl border-white/10' : 'bg-white/70 backdrop-blur-xl border-gray-100'} rounded-3xl p-4 shadow-xl hover:shadow-2xl border transition-shadow duration-300`}
                >
                  <div className={`inline-flex p-4 bg-gradient-to-br ${item.accent} rounded-2xl shadow-lg`}>
                    <item.icon className="w-8 h-8 text-white" strokeWidth={2} />
                  </div>
                  <div className="mt-2">
                    <p className={`text-sm tracking-wide ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{item.label}</p>
                    <p className={`text-4xl font-bold mt-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{item.value}</p>
                  </div>
                </motion.div>
              ))}
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-10">
              <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.15 }}
                className={`lg:col-span-2 ${isDarkMode ? 'bg-white/[0.06] backdrop-blur-xl border-white/10' : 'bg-white/70 backdrop-blur-xl border-gray-100'} rounded-3xl p-8 shadow-xl hover:shadow-2xl border transition-shadow duration-300`}
              >
                <h2 className={`text-xl font-bold mb-6 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Orders Overview (Last 7 Days)</h2>
                <div className="h-80">
                  <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={[
                      { name: "Mon", orders: 420 }, { name: "Tue", orders: 380 },
                      { name: "Wed", orders: 620 }, { name: "Thu", orders: 290 },
                      { name: "Fri", orders: 750 }, { name: "Sat", orders: 680 },
                      { name: "Sun", orders: 520 }
                    ]}>
                      <CartesianGrid strokeDasharray="3 3" stroke={isDarkMode ? '#333' : '#f1f1f1'} />
                      <XAxis dataKey="name" stroke={isDarkMode ? '#999' : '#666'} />
                      <YAxis stroke={isDarkMode ? '#999' : '#666'} />
                      <Tooltip />
                      <Line type="monotone" dataKey="orders" stroke="#8b5cf6" strokeWidth={4} dot={{ r: 5, fill: "#8b5cf6" }} />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.22 }}
                className={`${isDarkMode ? 'bg-white/[0.06] backdrop-blur-xl border-white/10' : 'bg-white/70 backdrop-blur-xl border-gray-100'} rounded-3xl p-8 shadow-xl hover:shadow-2xl border transition-shadow duration-300 flex flex-col`}
              >
                <h2 className={`text-xl font-bold mb-6 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Recent Activity</h2>
                <div className="space-y-5 flex-1 text-sm">
                  {[
                    "New order #10023 received",
                    "Order #10022 fulfilled",
                    "Order #10021 shipped via Delhivery"
                  ].map((act, i) => (
                    <div key={i} className="flex gap-4 items-start">
                      <div className="p-2 rounded-xl bg-gradient-to-br from-purple-500 to-indigo-600 shrink-0">
                        <ShoppingBag className="w-4 h-4 text-white" />
                      </div>
                      <div className={`${isDarkMode ? 'text-gray-300' : 'text-gray-700'} mt-1`}>{act}</div>
                    </div>
                  ))}
                </div>
                <button className={`mt-6 w-full py-3 rounded-2xl font-medium transition-all border ${isDarkMode ? 'border-white/10 hover:border-purple-400/40 hover:bg-white/5 text-gray-200' : 'border-gray-200 hover:border-purple-300 hover:bg-purple-50 text-gray-700'}`}>
                  View All Activity
                </button>
              </motion.div>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="mt-8"
            >
              <div className="flex justify-between items-center mb-6">
                <h2 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Recent Orders</h2>
                <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Latest orders from Shopify</p>
              </div>

              <div className={`${isDarkMode ? 'bg-white/[0.06] backdrop-blur-xl border-white/10' : 'bg-white/70 backdrop-blur-xl border-gray-100'} rounded-3xl shadow-xl border overflow-hidden`}>
                <table className="w-full">
                  <thead className={`${isDarkMode ? 'bg-white/5' : 'bg-gray-50'} border-b ${isDarkMode ? 'border-white/10' : 'border-gray-100'}`}>
                    <tr>
                      <th className={`px-6 py-4 text-left text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Order ID</th>
                      <th className={`px-6 py-4 text-left text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Customer</th>
                      <th className={`px-6 py-4 text-left text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Amount</th>
                      <th className={`px-6 py-4 text-left text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Status</th>
                      <th className={`px-6 py-4 text-left text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Date</th>
                    </tr>
                  </thead>
                  <tbody className={`divide-y ${isDarkMode ? 'divide-white/5' : 'divide-gray-100'}`}>
                    {currentOrders.map((order) => (
                      <tr key={order.id} className={`transition ${isDarkMode ? 'hover:bg-white/5' : 'hover:bg-purple-50/50'}`}>
                        <td className={`px-6 py-5 font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>#{order.id}</td>
                        <td className={`px-6 py-5 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{order.customer}</td>
                        <td className={`px-6 py-5 font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>₹{order.amount}</td>
                        <td className="px-6 py-5">
                          <span className={`px-3 py-1 text-xs font-semibold rounded-full 
                            ${order.status === 'Delivered' ? 'bg-green-100 text-green-700' :
                              order.status === 'Shipped' ? 'bg-blue-100 text-blue-700' :
                                'bg-amber-100 text-amber-700'}`}>
                            {order.status}
                          </span>
                        </td>
                        <td className={`px-6 py-5 text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{order.date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className={`flex items-center justify-between px-6 py-5 border-t ${isDarkMode ? 'border-white/10 bg-white/5' : 'border-gray-100 bg-gray-50'}`}>
                  <button
                    onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                    disabled={currentPage === 1}
                    className={`px-5 py-2 rounded-xl text-sm font-medium border transition disabled:opacity-40 ${isDarkMode ? 'border-white/10 hover:bg-white/10 text-gray-200' : 'border-gray-300 hover:bg-white text-gray-700'}`}
                  >
                    Previous
                  </button>
                  <span className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                    Page <span className={`font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{currentPage}</span> of {totalPages}
                  </span>
                  <button
                    onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    className={`px-5 py-2 rounded-xl text-sm font-medium border transition disabled:opacity-40 ${isDarkMode ? 'border-white/10 hover:bg-white/10 text-gray-200' : 'border-gray-300 hover:bg-white text-gray-700'}`}
                  >
                    Next
                  </button>
                </div>
              </div>
            </motion.div>


            {/* ==================== WAREHOUSE SELECTION MODAL ==================== */}
            <AnimatePresence>
              {showWarehouseModal && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
                >
                  <motion.div
                    initial={{ opacity: 0, y: 20, scale: 0.98 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 20, scale: 0.98 }}
                    transition={{ duration: 0.2 }}
                    className={`${isDarkMode ? 'bg-gray-900/95 border-white/10' : 'bg-white/95 border-gray-100'} backdrop-blur-xl rounded-3xl p-8 w-full max-w-md shadow-2xl border`}
                  >
                    <div className="flex justify-between items-center mb-6">
                      <h2 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Select Warehouse</h2>
                      <button
                        onClick={() => setShowWarehouseModal(false)}
                        className={`p-2 rounded-xl transition ${isDarkMode ? 'text-gray-400 hover:bg-white/10 hover:text-white' : 'text-gray-500 hover:bg-gray-100 hover:text-gray-700'}`}
                      >
                        <FiX size={22} />
                      </button>
                    </div>

                    <p className={`mb-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Select your pickup warehouse to sync orders from Shopify:</p>

                    {warehouseLoading ? (
                      <div className="py-8 text-center">
                        <FiRefreshCw className="animate-spin mx-auto text-purple-500" size={36} />
                        <p className={`mt-3 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Loading warehouses...</p>
                      </div>
                    ) : (
                      <select
                        value={selectedWarehouseId}
                        onChange={(e) => setSelectedWarehouseId(e.target.value)}
                        className={`w-full p-4 rounded-2xl border focus:outline-none focus:ring-4 focus:ring-purple-500/30 focus:border-purple-500 text-base transition ${isDarkMode ? 'bg-white/5 border-white/10 text-white' : 'bg-white border-gray-300 text-gray-900'}`}
                      >
                        <option value="">-- Select Warehouse --</option>
                        {warehouses.map((wh) => (
                          <option key={wh.id} value={wh.id}>
                            {wh.name || wh.warehouse_name} ({wh.id})
                          </option>
                        ))}
                      </select>
                    )}

                    <div className="flex gap-3 mt-8">
                      <button
                        onClick={() => setShowWarehouseModal(false)}
                        className={`flex-1 py-4 rounded-2xl font-medium transition border ${isDarkMode ? 'border-white/10 hover:bg-white/5 text-gray-200' : 'border-gray-300 hover:bg-gray-50 text-gray-700'}`}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={syncShopifyOrders}
                        disabled={!selectedWarehouseId || syncLoading}
                        className="flex-1 py-4 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white rounded-2xl font-medium transition shadow-lg shadow-purple-500/30 disabled:opacity-50"
                      >
                        {syncLoading ? 'Syncing...' : 'Sync Orders'}
                      </button>
                    </div>
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    );
  }
  // ==================== PENDING VIEW ====================
  if (status === 'pending') {
    return (
      <div className={`flex flex-col ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
        <div className={`flex items-center justify-center p-6 relative overflow-hidden ${isDarkMode ? 'bg-darkmodeColor' : 'bg-gray-50'}`}>
          <div className="pointer-events-none absolute inset-0 overflow-hidden">
            <div className="absolute -top-24 left-1/4 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl" />
            <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl" />
          </div>
          <motion.div
            className={`max-w-md w-full relative ${isDarkMode ? 'bg-white/[0.06] backdrop-blur-xl border-amber-400/20' : 'bg-white/80 backdrop-blur-xl border-amber-200'} rounded-3xl p-10 shadow-2xl border text-center`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <div className="inline-flex p-5 rounded-2xl bg-gradient-to-br from-amber-400 to-orange-500 shadow-lg shadow-amber-500/30">
              <FiAlertCircle className="text-white" size={40} />
            </div>
            <h2 className={`text-3xl font-bold mt-6 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Connection Pending</h2>
            <p className={`mt-4 text-lg leading-relaxed ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{statusMessage}</p>

            <div className={`mt-8 p-5 rounded-2xl text-left border ${isDarkMode ? 'bg-amber-500/10 border-amber-400/20' : 'bg-amber-50 border-amber-100'}`}>
              <p className="font-semibold text-amber-600">What to do next?</p>
              <p className="text-amber-600/80 mt-2 text-sm">Please contact the administrator to approve your Shopify connection request.</p>
            </div>

            <button
              onClick={checkConnectionStatus}
              className={`mt-8 w-full py-4 rounded-2xl font-semibold transition border-2 ${isDarkMode ? 'border-white/10 hover:border-purple-400/40 text-white hover:bg-white/5' : 'border-gray-200 hover:border-purple-300 text-gray-800 hover:bg-purple-50'}`}
            >
              Refresh Status
            </button>
          </motion.div>
        </div>
      </div>
    );
  }

  // ==================== CONNECT FORM (Not Connected) ====================
  return (
    <div className={`flex flex-col ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className={`flex items-center justify-center p-6 relative overflow-hidden ${isDarkMode ? 'bg-darkmodeColor' : 'bg-gray-50'}`}>
        {/* Background Glow */}
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          <div className="absolute -top-24 left-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl" />
          <div className="absolute top-1/3 right-0 w-96 h-96 bg-indigo-500/10 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-80 h-80 bg-fuchsia-500/10 rounded-full blur-3xl" />
        </div>

        <motion.div
          className="w-full max-w-5xl grid grid-cols-1 lg:grid-cols-2 gap-8 items-center relative"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
        >
          {/* Left Info */}
          <div className="space-y-8">
            <div className="flex items-center gap-4">
              <div className="h-16 w-16 bg-gradient-to-br from-purple-600 to-indigo-600 rounded-2xl flex items-center justify-center text-white text-3xl font-bold shadow-lg shadow-purple-500/30">S</div>
              <div>
                <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full mb-2 border ${isDarkMode ? 'bg-white/5 border-white/10 text-purple-300' : 'bg-purple-50 border-purple-200 text-purple-600'} text-xs font-semibold tracking-wide uppercase`}>
                  <Sparkles className="w-3 h-3" />
                  Channel Integration             
                </div>
                <h1 className={`text-4xl font-extrabold tracking-tight ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Connect Shopify</h1>
                <p className={`mt-2 text-lg ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Sync orders instantly with PickupXpress</p>
              </div>
            </div>

            <div className="space-y-4 pl-2">
              {[
                "Enter your Shopify store URL",
                "Authorize PickupXpress in your Shopify admin",
                "Orders will start syncing automatically",
                "Track all shipments from one dashboard"
              ].map((text, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: -12 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.4, delay: 0.15 + i * 0.08 }}
                  className="flex items-start gap-4"
                >
                  <div className="mt-0.5 h-7 w-7 rounded-full bg-gradient-to-br from-purple-500 to-indigo-600 text-white flex items-center justify-center text-sm font-bold flex-shrink-0 shadow-md shadow-purple-500/20">
                    {i + 1}
                  </div>
                  <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-700'} pt-0.5`}>{text}</p>
                </motion.div>
              ))}
            </div>

            <div className={`flex items-center gap-3 text-sm pl-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
              <FiLock className="text-purple-500" /> Secure connection • Revoke anytime
            </div>
          </div>

          {/* Right Form */}
          <motion.div
            className={`${isDarkMode ? 'bg-white/[0.06] backdrop-blur-xl border-white/10' : 'bg-white/80 backdrop-blur-xl border-gray-100'} rounded-3xl p-8 shadow-2xl border`}
            initial={{ x: 40, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.1 }}
          >
            <div className="space-y-6">
              <div>
                <div className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-sm font-medium ${isDarkMode ? 'bg-purple-500/10 text-purple-300' : 'bg-purple-50 text-purple-700'}`}>
                  <FiLink /> Shopify Secure Connect
                </div>
                <h2 className={`text-2xl font-bold mt-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Store Connection</h2>
              </div>

              <div>
                <label className={`block text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Shopify Store URL</label>
                <div className="relative">
                  <FiExternalLink className={`absolute left-4 top-4 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`} />
                  <input
                    type="text"
                    value={storeUrl}
                    onChange={handleUrlChange}
                    placeholder="https://yourstore.myshopify.com"
                    className={`w-full pl-11 pr-4 py-4 rounded-2xl border focus:outline-none focus:ring-4 focus:ring-purple-500/20 text-base transition
                                            ${isDarkMode ? 'bg-white/5 text-white placeholder:text-gray-500' : 'bg-white text-gray-900'}
                                            ${fieldError ? 'border-red-400' : isValidUrl(storeUrl) ? 'border-purple-500' : isDarkMode ? 'border-white/10' : 'border-gray-300'}`}
                  />
                  {touched && isValidUrl(storeUrl) && <FiCheck className="absolute right-4 top-4 text-green-500" size={24} />}
                </div>
                {fieldError && <p className="text-red-500 text-sm mt-2 flex items-center gap-1"><FiAlertCircle />{fieldError}</p>}
                {hint && <p className="text-purple-500 text-sm mt-2">{hint}</p>}
              </div>

              <button
                onClick={handleSubmit}
                disabled={!isValidUrl(storeUrl)}
                className="w-full py-4 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 disabled:opacity-50 text-white font-semibold rounded-2xl text-lg shadow-lg shadow-purple-500/30 transition-all flex items-center justify-center gap-3"
              >
                <FiLink size={22} />
                Connect Shopify Store
              </button>

              <p className={`text-center text-xs ${isDarkMode ? 'text-gray-500' : 'text-gray-500'}`}>We never ask for your Shopify password.</p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}